'use strict';

var React = require('react');

var SvgBlogIcon = function SvgBlogIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.747 2.354c.195-.196.512-.196.707 0l1.06 1.06c.196.195.196.512 0 .707l-.956.957-1.768-1.767.957-.957Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.083 4.018 1.768 1.768-2.831 2.83c-.359.359-.84.568-1.348.585l-.772.025c-.144.005-.263-.113-.258-.258l.026-.772c.016-.507.225-.989.584-1.348l2.83-2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.75c0-.69.56-1.25 1.25-1.25h4.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4.5c-1.519 0-2.75 1.231-2.75 2.75v8.5c0 1.519 1.231 2.75 2.75 2.75h6.5c1.519 0 2.75-1.231 2.75-2.75v-4.5c0-.414-.336-.75-.75-.75s-.75.336-.75.75v4.5c0 .69-.56 1.25-1.25 1.25h-6.5c-.69 0-1.25-.56-1.25-1.25v-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 12.75c-.414 0-.75.336-.75.75s.336.75.75.75h2.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 10.75c0-.414.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75h-4.5c-.414 0-.75-.336-.75-.75Z"
  }));
};
SvgBlogIcon.displayName = "BlogIcon";

exports.SvgBlogIcon = SvgBlogIcon;
